import SuccessMappingAlert from './SuccessMappingAlert';

export default SuccessMappingAlert;
